import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { signInStart } from 'redux/user/user.action';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  focusElement,
  getFormData,
  emailValidate,
  showToast,
} from 'util/utils';
import { RiEyeCloseLine } from 'react-icons/ri';
import { ImEye } from 'react-icons/im';
import AlincoLogo from 'asset/img/alinco_logo.png';
import './ForgetPassword.scss';

const STEP_RECOVERY_BEGIN = 0;
const STEP_RECOVERY_OTP = 1;
const STEP_RECOVERY_NEW_PASS = 2;
const STEP_RECOVERY_FINISH = 3;

const InputText = ({
  type = 'text',
  title,
  id,
  placeholder,
  iconClick = () => {},
  iconShow = false,
  showPassword = false,
  showClick = () => {},
  hideClick = () => {},
  handleClick = () => {},
}) => {
  const props = { id, name: id, type };

  if (!!placeholder) {
    props['placeholder'] = placeholder;
  }

  return (
    <>
      {!!title && type !== 'hidden' && (
        <h6
          style={{
            fontWeight: '600',
            textAlign: 'left',
            paddingLeft: '10px',
            marginTop: '10px',
            marginBottom: '5px',
          }}
        >
          {title}
        </h6>
      )}
      <InputGroup>
        <Form.Control {...props} />
        {!!iconShow &&
          (showPassword ? (
            <InputGroup.Text>
              <ImEye onClick={() => handleClick()} />
            </InputGroup.Text>
          ) : (
            <InputGroup.Text>
              <RiEyeCloseLine onClick={() => handleClick()} />
            </InputGroup.Text>
          ))}
      </InputGroup>
    </>
  );
};

const initialState = {
  email: '',
  password: '',
  confirmPassword: '',
  usernameKanji: '',
  usernameHira: '',
  phoneNumber: '',
  otp: '',
  isLoading: false,
  isError: false,
  isAuth: false,
};

const ForgetPassword = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const dispatch = useDispatch();
  const history = useHistory();
  const [resetPasswordStep, setResetPasswordStep] =
    useState(STEP_RECOVERY_BEGIN);
  const [userData, setUserData] = useState(initialState);
  //const [mailHint, setMailHint] = useState('');
  //const [loginID, setLoginID] = useState('');
  //const [activeCode, setActiveCode] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [showForm1, setShowForm1] = useState(true);
  const [showForm2, setShowForm2] = useState(false);
  const [showForm3, setShowForm3] = useState(false);

  //------------------------FUNCTIONS----------------------------------------------------------
	useEffect(() => {
		if (!!showForm1) {
			setTimeout(() => {
				focusElement('#email');
			},10);
		}
	},[showForm1]);

	useEffect(() => {
		if (!!showForm2) {
			const timerId = setTimeout(() => {
				focusElement('#otp');
			},10);
			return () => {
				clearTimeout(timerId);
			}
		}
	},[showForm2]);

	useEffect(() => {
		if (!!showForm3) {
			const timerId = setTimeout(() => {
				focusElement('#password');
			},10);
			return () => {
				clearTimeout(timerId);
			}
		}
	},[showForm3]);

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (resetPasswordStep === STEP_RECOVERY_BEGIN) {
      let formData = getFormData(e.target, {
        rawCol: {
          email: true,
        },
      });
      if (!formData?.email) {
        showToast(string.MAIL_ADDRESS_EMPTY_ERR);
        focusElement('#email');
        return;
      }
      if (!emailValidate(formData.email)) {
        showToast(string.MAIL_ADDRESS_FORMAT_ERR);
        focusElement('#email');
        return;
      }
      sendPost({
        url: Urls.account.resetpassword,
        body: {
          email: formData?.email,
        },
        withToken: false,
      })
        .then((res) => {
          setResetPasswordStep(STEP_RECOVERY_OTP);
          setShowForm1(false);
          setShowForm2(true);
          setShowForm3(false);

          let beginState = userData;
          beginState.email = formData?.email;
          setUserData(beginState);
        })
        .catch((e) => {
          //console.log(e);
          const message = e;
          if (message === string.PASSWORD_RECOVERY_EMAIL_NOT_EXIST_ERR) {
            focusElement('#email');
          }
        });
    } else if (resetPasswordStep === STEP_RECOVERY_OTP) {
      let formData = getFormData(e.target, {
        rawCol: {
          otp: true,
        },
      });
      if (!formData.otp) {
        showToast(string.OTP_EMPTY_ERR);
        focusElement('#otp');
        return;
      }
			const otp = {
				otp: formData.otp.toUpperCase(),
			};
      sendPost({
        url: Urls.account.resetpasswordotp,
        body: {
          email: userData?.email,
          ...otp,
        },
        withToken: false,
      })
        .then((res) => {
          setResetPasswordStep(STEP_RECOVERY_NEW_PASS);
          setShowForm1(false);
          setShowForm2(false);
          setShowForm3(true);

          let otpState = userData;
          otpState.otp = otp.otp;
          setUserData(otpState);
        })
        .catch((e) => {
          //console.log(e);
          const message = e;
          if (message === string.PASSWORD_RECOVERY_OPT_ERR) {
            focusElement('#otp');
          }
        });
    } else if (resetPasswordStep === STEP_RECOVERY_NEW_PASS) {
      let formData = getFormData(e.target, {
        rawCol: {
          password: true,
          passwordConfirm: true,
        },
      });
      if (!formData.password) {
        showToast(string.PASSWORD_EMPTY_ERR);
        focusElement('#password');
        return;
      }
			if (!formData.passwordConfirm) {
				showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
				focusElement('#passwordConfirm');
				return;
			}
			if (formData.password !== formData.passwordConfirm) {
				showToast(string.PASSWORD_CONFIRM_ERR);
				focusElement('#password');
				return;
			}
      // if (!showPassword) {
      //   if (!formData.passwordConfirm) {
      //     showToast(string.CONFIRM_PASSWORD_EMPTY_ERR);
      //     focusElement('#passwordConfirm');
      //     return;
      //   }
      //   if (formData.password !== formData.passwordConfirm) {
      //     showToast(string.PASSWORD_CONFIRM_ERR);
      //     focusElement('#password');
      //     return;
      //   }
      // }

      let resetPassword = {
        email: userData?.email,
        otp: userData?.otp,
        password: formData?.password,
      };

      sendPost({
        url: Urls.account.resetpasswordotp,
        body: resetPassword,
        withToken: false,
      })
        .then(async (res) => {
          let loginData = {
            email: userData?.email,
            password: formData?.password,
          };
          await dispatch(signInStart(loginData));
          history.push(Paths.root);
        })
        .catch((e) => {
          //console.log(e);
          const message = e;
        });
    } else {
    }
  };

  const onClick = () => {
    let passwordShow = !showPassword;
    setShowPassword(passwordShow);
  };

  //------------------------------------RETURN---------------------------------------------------------
  return (
    <>
      <div className="screen-forget-password">
        <div className="wrapper fadeInDown">
					<div id='logoBox'>
						<img
							alt="layout"
							width="60%"
							height="60%"
							src={AlincoLogo}
						/>
					</div>
          <div id="formContent">
            <h2 className="active">{string.PASSWORD_RECOVERY_TITLE}</h2>
            <div className="card-body">
              <Form onSubmit={onSubmit}>
                {showForm1 && (
                  <>
                    <InputText
                      title={string.PASSWORD_RECOVERY_MAIL_TITLE}
                      id="email"
                      placeholder={string.PASSWORD_RECOVERY_MAIL_SAMPLE}
                    />
                    <div>
                      <Button type="submit" className="button-submit">
                        {string.PASSWORD_RECOVERY}
                      </Button>
                    </div>
                  </>
                )}

                {showForm2 && (
                  <>
                    <InputText
                      title={string.PASSWORD_RECOVERY_OTP_TITLE}
                      id="otp"
                      placeholder={string.PASSWORD_RECOVERY_OPT_SAMPLE}
                    />
                    <div>
                      <Button type="submit" className="button-submit">
                        {string.PASSWORD_RECOVERY_OPT_CONFIRM}
                      </Button>
                    </div>
										<div style={{marginTop:'10px',display:'flex', justifyContent:'left'}}>
											【認証コードについて】
										</div>
										<div style={{display:'flex', justifyContent:'left'}}>
											　・メール送付から5分間有効です。
										</div>
										<div style={{display:'flex', justifyContent:'left'}}>
											　・一度使用すると無効になります。
										</div>
										<div style={{display:'flex', justifyContent:'left'}}>
											　・無効になった場合はアカウント登録を最初から行ってください。
										</div>
                  </>
                )}

                {showForm3 && (
                  <>
                    <InputText
                      type={showPassword ? 'text' : 'password'}
                      title={string.PASSWORD_RECOVERY_NEW_PASSWORD_TITLE}
                      id="password"
                      placeholder={string.PASSWORD_RECOVERY_NEW_PASSWORD_SAMPLE}
                      iconShow={true}
                      showPassword={showPassword}
                      handleClick={onClick}
                    />
                    <InputText
                      type={showPassword ? 'text' : 'password'}
                      // type={showPassword ? 'hidden' : 'password'}
                      title={
                        string.PASSWORD_RECOVERY_NEW_PASSWORD_CONFIRM_TITLE
                      }
                      id="passwordConfirm"
                      placeholder={
                        string.PASSWORD_RECOVERY_NEW_PASSWORD_CONFIRM_SAMPLE
                      }
                      iconShow={!showPassword}
                      showPassword={showPassword}
                      handleClick={onClick}
                    />
                    <div>
                      <Button type="submit" className="button-submit">
                        {string.PASSWORD_RECOVERY}
                      </Button>
                    </div>
                  </>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
